import React, {useState} from 'react';
import MaxWidthDiv from "../../../ui/MaxWitdthDiv";
import useApiGetMyCompanyRegistry from "./my_company_registry/api-hooks/useApiGetMyCompanyRegistry";
import MyCompanyRegistryCard from "./my_company_registry/MyCompanyRegistryCard";
import {Box} from "@mui/material";
import MuiFabButtonBase from "../../../ui/mui/mui_buttons/fab/extended/MuiFabButtonBase";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import MuiModal from "../../../ui/mui/mui_modal/MuiModal";
import MyCompanyWarehouseTable from "./my_company_warehouse/MyCompanyWarehouseTable";
import FactoryIcon from '@mui/icons-material/Factory';
import MyCompanySiteTable from "./my_company_site/MyCompanySiteTable";


const MyCompanyScreen = () => {

    const {data} = useApiGetMyCompanyRegistry();
    const [isMyCompanyWarehouseTableOpen, setIsMyCompanyWarehouseTableOpen] = useState<boolean>(false)
    const [isMyCompanySiteTableOpen, setIsMyCompanySiteTableOpen] = useState<boolean>(false)

    return (
        <>

            <MaxWidthDiv maxWidth='1024px'>
                <Box sx={{marginTop: 2}}>
                    <Box sx={{py: 1}}>
                        <MyCompanyRegistryCard obj={data}/>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'row', py: 1}}>
                        <Box sx={{mr: 2}}> {/* Adds margin-right for spacing */}
                            <MuiFabButtonBase
                                icon={<WarehouseIcon/>}
                                label={'warehouses'}
                                onClick={() => setIsMyCompanyWarehouseTableOpen(true)}
                            />
                        </Box>
                        <Box>
                            <MuiFabButtonBase
                                icon={<FactoryIcon/>}
                                label={'sites'}
                                onClick={() => setIsMyCompanySiteTableOpen(true)}
                            />
                        </Box>
                    </Box>
                </Box>

                <MuiModal top="50%" left="50%" width={'120vh'} open={isMyCompanyWarehouseTableOpen}
                          onClose={() => setIsMyCompanyWarehouseTableOpen(false)}
                          disableBackdropClick={true}
                >
                    <MyCompanyWarehouseTable
                        alreadySelectedObj={undefined}
                        onSelect={undefined}
                        onClose={() => setIsMyCompanyWarehouseTableOpen(false)}
                    />
                </MuiModal>

                <MuiModal top="50%" left="50%" width={'120vh'} open={isMyCompanySiteTableOpen}
                          onClose={() => setIsMyCompanySiteTableOpen(false)}
                          disableBackdropClick={true}
                >
                    <MyCompanySiteTable
                        alreadySelectedObj={undefined}
                        onSelect={undefined}
                        onClose={() => setIsMyCompanySiteTableOpen(false)}
                    />
                </MuiModal>

            </MaxWidthDiv>


        </>
    );
};

export default MyCompanyScreen;
